import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Sidebar() {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <aside className="sidebar w-64 hidden md:block">
      <nav className="p-6 space-y-2">
        <Link
          to="/"
          className={`block px-4 py-3 rounded-lg transition-colors ${isActive('/') ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-gray-700 hover:bg-gray-100'}`}
        >
          📊 Dashboard
        </Link>
        <Link
          to="/templates"
          className={`block px-4 py-3 rounded-lg transition-colors ${isActive('/templates') ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-gray-700 hover:bg-gray-100'}`}
        >
          📋 Templates
        </Link>
        <Link
          to="/builder"
          className={`block px-4 py-3 rounded-lg transition-colors ${isActive('/builder') ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-gray-700 hover:bg-gray-100'}`}
        >
          🔨 Workflow Builder
        </Link>
        <Link
          to="/executions"
          className={`block px-4 py-3 rounded-lg transition-colors ${isActive('/executions') ? 'bg-blue-100 text-blue-700 font-semibold' : 'text-gray-700 hover:bg-gray-100'}`}
        >
          ⚙️ Executions
        </Link>
      </nav>
    </aside>
  );
}
